import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ConfirmDialog, Spinner } from "components/common";
import ProviderName from "ai-management/components/ProviderName";
import useConfiguredModelProviders from "ai-management/model-providers/hooks/useConfiguredModelProviders";
import DeleteConsequence from "ai-management/model-providers/delete/DeleteConsequence";
const DeleteModelProviderDialog = ({ provider, isDeleting, onConfirm, onCancel }) => {
  const { t } = useTranslation("enterprise_ai");
  const { data: providers, isLoading } = useConfiguredModelProviders();
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: t("delete_provider_dialog.title"),
      btnConfirmText: t("delete_provider_dialog.confirm"),
      btnConfirmDisabled: isLoading,
      isAsyncSubmit: true,
      isSubmitting: isDeleting,
      submitLoadingText: t("delete_provider_dialog.deleting"),
      onConfirm,
      onCancel
    },
    isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DeleteConsequence, { provider, providers }), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "delete_provider_dialog.message",
        components: { providerName: /* @__PURE__ */ React.createElement(ProviderName, { providerId: provider.provider }) }
      }
    )))
  );
};
export default DeleteModelProviderDialog;
